import React from "react";
import Mainbar from "./modules/Mainbar";
import Sidebar from "./modules/Sidebar";

export default () => {
  return (
    <div className="d-flex ">
      <Sidebar />
      <Mainbar />
    </div>
  );
};
